import { useState } from 'react';
import {
  AssessmentButtons,
  AssessmentCard,
  AssessmentCrisisAlert,
} from '../shared';
import { useAppDispatch } from '../../../pages/assessment';
import { updateMeta } from '../../../redux/meta';
import { WhatIsPsychiatryList } from '../icon-lists';

const IntroScreenTwo = () => {
  const dispatch = useAppDispatch();
  const [isContinuing, setIsContinuing] = useState(false);
  const onClick = () => {
    setIsContinuing(true);
    dispatch(updateMeta());
  };

  return (
    <>
      <AssessmentCard>
        <WhatIsPsychiatryList />
      </AssessmentCard>
      <AssessmentCrisisAlert />
      <AssessmentButtons
        primary={{
          children: 'Continue',
          fullWidth: true,
          disabled: isContinuing,
          loading: isContinuing,
          onClick,
        }}
      />
    </>
  );
};

export default IntroScreenTwo;
